import { render } from "./VerLogisticaVentas.vue?vue&type=template&id=2a03174e&scoped=true"
import script from "./VerLogisticaVentas.vue?vue&type=script&lang=js"
export * from "./VerLogisticaVentas.vue?vue&type=script&lang=js"

import "./VerLogisticaVentas.vue?vue&type=style&index=0&id=2a03174e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a03174e"]])

export default __exports__